import {useEffect,useState} from 'react';
import AudioWaveform from './AudioWaveform';
import {getRangeWaveform} from '../lib/rangeWaveform.js';

// Real audio amplitude at source timecodes, decoded on demand using byte ranges.
export default function RefineWaveform({url,start,end,detail=false}){
 const key=url+'|'+start+'|'+end;
 const [state,setState]=useState({key:'',status:'loading'});
 useEffect(()=>{
  if(!url||!Number.isFinite(start)||!Number.isFinite(end)||end<=start)return;
  let mounted=true;
  getRangeWaveform(url,start,end).then(data=>{
   if(mounted)setState({key,status:'ready',data});
  }).catch(()=>{
   if(mounted)setState({key,status:'unavailable'});
  });
  return()=>{mounted=false;};
 },[url,start,end,key]);
 const status=state.key===key?state.status:'loading';
 return <div className={'rr-waveform'+(detail?' rr-waveform-detail':'')} aria-label="Source audio waveform">
  {status==='ready'&&<AudioWaveform audio={state.data} start={start} end={end}/>}
  {detail&&status!=='ready'&&<span className="rr-waveform-feedback" role="status">
   {url?(status==='loading'?'Reading source audio…':'Audio waveform unavailable for this source'):'Load video to inspect source audio'}
  </span>}
 </div>;
}
